import { Stack as MantineStack } from "@mantine/core";

export const Stack = MantineStack;
